export const GOOGLE_LOGIN_TEST_STORAGE_KEY = 'googleTest';

export const isGoogleLoginTestEnabled = (): boolean => localStorage.getItem(GOOGLE_LOGIN_TEST_STORAGE_KEY) === 'true';
